// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__270cv","info":"PatientInfo_info__3Ifpf"};